import React, { useState } from "react";
import { Container, Tab } from "@mui/material";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import TabsMenu from "../../components/TabsMenu";
import { TabPanel } from "@mui/lab";
import Mismatch from "./mismatch";
import Reconciled from "./reconciled";

const PayoutReconciliation = () => {
  const [selectedView, setSelectedView] = useState("Reconciled");

  const handleChange = (event, value) => {
    setSelectedView(value);
  };

  return (
    <Container>
      <HeaderHelpPage title="Payout Reconciliation" />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="Reconciled" value="Reconciled" />
        <Tab label="Skip Reconciled" value="SkipReconciled" />
        <TabPanel value="Reconciled">
          <Reconciled />
        </TabPanel>
        <TabPanel value="SkipReconciled">
          <Mismatch />
        </TabPanel>
      </TabsMenu>
    </Container>
  );
};

export default PayoutReconciliation;
